"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectNotNull = void 0;
const is_object_1 = require("../is-object/is-object");
/**
 * Returns true if the element has the type object and is not null
 * @public
 *
 * @param arg - A generic argument to check
 *
 * @returns A boolean indicating whether the arg is an Object (excluding null) or not.
 *
 * @example
 * ```ts
 * const result = isObject({});
 * console.log(result);
 * // -> true
 * ```
 **/
function isObjectNotNull(arg) {
    return (0, is_object_1.isObject)(arg) && arg !== null;
}
exports.isObjectNotNull = isObjectNotNull;
//# sourceMappingURL=is-object-not-null.js.map